<div *ngIf="editCheck==true && isAccessible">
    <img src="assets/images/noun_edit.svg" alt="edit" style="width:17px;height:16px; cursor:pointer;" 
    (click)="this.resolutionOrders()"/>
  </div>
